import React from 'react';
import Breadcrumbs from '~/components/Breadcrumbs';
import CompanyBanner from '~/components/Companies/CompanyBanner';
import CompanyPartnership from '~/components/Companies/CompanyPartnership';
import { currentUrl } from '~/helpers/projectConstant';
import DefaultLayout from '~/layouts/DefaultLayout';
import { BreadcrumbLink } from '~/types/common/Breadcrumb';
import type { ProviderPartnershipProps } from '~/types/Provider';

export const ProviderPartnership: React.FC<ProviderPartnershipProps> = ({
  name,
  slug,
  logoUrl,
  partnerText,
  banner,
}) => {
  const breadcrumbLinks: BreadcrumbLink[] = [
    { name: 'Home', linkTo: '/' },
    { name: 'Aanbieders', linkTo: '/over/aanbieders' },
    { name, linkTo: `/over/aanbieder/${slug}` },
    { name: 'Samenwerking', linkTo: currentUrl },
  ];

  return (
    <DefaultLayout
      breadcrumbs={<Breadcrumbs links={breadcrumbLinks} variant="inverted" />}
      bgClassName="bg-blue-700"
    >
      <CompanyBanner
        banner={banner}
        companyName={name}
        companyLogo={logoUrl}
        companyType="provider"
        backButton={{
          link: `/over/aanbieder/${slug}`,
          type: 'provider',
        }}
      />
      <CompanyPartnership partnerText={partnerText} />
    </DefaultLayout>
  );
};
